import React from 'react'
import StyledButton from '../../styled/styled-button'

const Button = ({onClick, buttonTitle, value}) => {
  return(
    <StyledButton onClick={onClick} value={value}>
      {buttonTitle}
    </StyledButton>
  )
}

export default Button